<template>
    <div>
        <a href="javascript:void(0)" class="system-btn h24 row-path-btn" @click.prevent="openFilter">
            <p>{{ lang($t("Filter")) }}</p>
            <div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
                    <path d="M26,48c4.418,0,8-3.582,8-8c0-4.418-3.582-8-8-8s-8,3.582-8,8C18,44.418,21.581,48,26,48z M54,74
                    c4.418,0,8-3.582,8-8s-3.582-8-8-8s-8,3.582-8,8S49.582,74,54,74z M54,22c4.418,0,8-3.582,8-8s-3.582-8-8-8s-8,3.582-8,8
                    S49.582,22,54,22z M40.58,10C42.301,4.217,47.658,0,54,0s11.699,4.217,13.42,10h7.941c2.562,0,4.639,1.794,4.639,4
                    c0,2.211-2.076,4-4.639,4H67.42C65.699,23.784,60.342,28,54,28s-11.699-4.217-13.42-10H4.638C2.075,18,0,16.213,0,14.001
                    c0-2.206,2.075-4,4.638-4H40.58z M67.42,70C65.699,75.783,60.342,80,54,80s-11.699-4.217-13.42-10H4.638C2.075,70,0,68.213,0,66
                    c0-2.205,2.075-4,4.638-4H40.58c1.721-5.783,7.079-10,13.42-10s11.699,4.217,13.42,10h7.941C77.924,62,80,63.795,80,66
                    c0,2.211-2.076,4-4.639,4H67.42z M39.42,44C37.699,49.783,32.341,54,26,54S14.3,49.783,12.579,44H4.638C2.075,44,0,42.213,0,40
                    c0-2.205,2.075-4,4.638-4h7.941C14.3,30.217,19.658,26,26,26s11.699,4.217,13.42,10h35.941C77.924,36,80,37.795,80,40
                    c0,2.212-2.076,4-4.639,4H39.42z"></path>
                </svg>
            </div>
        </a>
        <div
            id="filter"
            :class="['box-model', classDisplayMode]"
            v-show="isShow"
        >
            <div class="overlay-mask"></div>
            <div class="outter-wrapper">
                <!--head-->
                <div class="head">
                    <div class="head-content">
                        <div class="head-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
                                <path d="M39.4202426,44 C37.6991443,49.7829779 32.3420413,54 26,54 C19.6579587,54 14.3008557,49.7829779 12.5797574,44 L4.63809316,44 C2.07522414,44 0,42.2131792 0,40 C0,37.7951445 2.07522414,36 4.63809316,36 L12.5797574,36 C14.3008557,30.2170221 19.6579587,26 26,26 C32.3420413,26 37.6991443,30.2170221 39.4202426,36 L75.3619068,36 C77.9247759,36 80,37.7951445 80,40 C80,42.2122543 77.9247759,44 75.3619068,44 L39.4202426,44 Z M67.4202426,70 C65.6991443,75.7829779 60.3420413,80 54,80 C47.6579587,80 42.3008557,75.7829779 40.5797574,70 L4.63809316,70 C2.07522414,70 0,68.2131792 0,66 C0,63.7951445 2.07522414,62 4.63809316,62 L40.5797574,62 C42.3008557,56.2170221 47.6579587,52 54,52 C60.3420413,52 65.6991443,56.2170221 67.4202426,62 L75.3619068,62 C77.9247759,62 80,63.7951445 80,66 C80,68.2104046 77.9247759,70 75.3619068,70 L67.4202426,70 Z M40.5797574,10 C42.3008557,4.21702211 47.6579587,0 54,0 C60.3420413,0 65.6991443,4.21702211 67.4202426,10 L75.3619068,10 C77.9247759,10 80,11.7944271 80,14.0004625 C80,16.2120476 77.9247759,18 75.3619068,18 L67.4202426,18 C65.6991443,23.7829779 60.3420413,28 54,28 C47.6579587,28 42.3008557,23.7829779 40.5797574,18 L4.63809316,18 C2.07522414,18 0,16.2129726 0,14.0004625 C0,11.7944271 2.07522414,10 4.63809316,10 L40.5797574,10 Z M54,22 C58.418278,22 62,18.418278 62,14 C62,9.581722 58.418278,6 54,6 C49.581722,6 46,9.581722 46,14 C46,18.418278 49.581722,22 54,22 Z M54,74 C58.418278,74 62,70.418278 62,66 C62,61.581722 58.418278,58 54,58 C49.581722,58 46,61.581722 46,66 C46,70.418278 49.581722,74 54,74 Z M26,48 C30.418278,48 34,44.418278 34,40 C34,35.581722 30.418278,32 26,32 C21.581722,32 18,35.581722 18,40 C18,44.418278 21.581722,48 26,48 Z"></path>
                            </svg>
                        </div>
                        <h2>{{ lang($t("Filter")) }}</h2>
                        <a @click="closeFilter" href="javascript:void(0)" class="btn-close dark"  :tooltip="lang($t('Close'))"  flow="down">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
                                    <path d="M76 11.251l-7.252-7.251-28.748 28.749-28.749-28.749-7.251 7.251 28.749 28.749-28.749 28.748 7.251 7.252 28.749-28.748 28.748 28.748 7.252-7.252-28.748-28.748z"></path>
                                </svg>
                            </div>
                        </a>
                    </div>
                </div>
                <!--end head-->
            </div>


            <!--body-->
            <VuePerfectScrollbar
                class="body"
                :settings="{ maxScrollbarLength: 100}"
            >
                <div
                    class="filter-criteria"
                    :class="`filter-${criterion.display_type}`"
                     v-for="(criterion,criterionIndex) in criteria"
                >
                    <h4 class="text-secondary">{{ criterion.display_name}}</h4>

                    <div v-if="criterion.display_type === 'checkbox' || criterion.display_type === 'radio'">
                        <ul>
                            <li v-for="(option, optionIndex) in criterion.options">
                                <input :type="criterion.display_type"
                                       name="layout"
                                       :id="option.id"
                                       :value="option.id"
                                       :checked="setIsChecked(criterionIndex, option.id)"
                                       @click="setFilteredValues($event, criterionIndex, optionIndex, option.id)"
                                >
                                <label class="pull-right text"
                                       :for="option.id"
                                >
                                    {{ option.value }}
                                </label>
                            </li>
                        </ul>
                    </div>
                    <div v-if="criterion.display_type === 'range'">
                        <div class="slider-wrapper">
                            <vue-slider ref="slider"
                                        v-model="sliderValues[criterionIndex]"
                                        event-type="auto"
                                        width="100%"
                                        :height="6"
                                        :dot-size="16"
                                        :min="0"
                                        :max="Math.max(...sliderRanges[criterionIndex])"
                                        :interval="1"
                                        :speed="0"
                                        :reverse="false"
                                        :show="criterion.display_type === 'range'"
                                        :formatter="(value)=>{
                                            return sliderToolTipFormatter(value,criterion.lom_field, criterionIndex);
                                        }"
                                        :start-animation="false"


                                        @callback="onSlided(criterionIndex)"
                            ></vue-slider>
                            <!-- :tooltip-style="styleSliderToolTip" -->
                            <!--:process-style="styleSliderProcessBg"-->
                            <!-- :bg-style="styleSliderBg" -->
                        </div>
                    </div>
                </div>
            </VuePerfectScrollbar>
            <!--end body-->

            <!--foot-->
            <div class="foot">
                <a href="javascript:void(0)" @click="resetFilter"  class="system-btn h32">
                    <p>{{ lang($t("Reset")) }}</p>
                </a>
                <a href="javascript:void(0)" @click="filterSubCate" class="action-btn h32">
                    <p>{{ lang($t("Confirm")) }}</p>
                </a>
            </div>
            <!--end foot-->

        </div>
    </div>

</template>

<script>

    import Vue from 'vue';
    import {common} from "@mixins/common";
    import {storeMapper} from '@mixins/storeMapper';
    import cssvar from '@sass/_variables.scss';
    import EventBus from '@common/eventBus';
    import VueSlider from 'vue-slider-component';
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import {cloneDeep} from 'lodash';
    import XAPIJS from "xapijs";

    export default {
        name: "SubCateFilter",
        mixins:[common,storeMapper],
        data() {
            return {
                isShow: false,
                criteria:null,
                sliderRanges:[],
                sliderValues:[],
                filterMapping:[], //filter settings made by user.
                filterMappingfrozen:[] //a copy of the filterMapping for restoring if user cancels the filter setting
            }
        },
        components: {
            VueSlider,
            VuePerfectScrollbar
        },
        beforeRouteUpdate (to, from, next) {
            this.isShow = false;
        },
        computed: {
            classDisplayMode() {
                return (this.$mq === cssvar.narrow) ? "view-full" : "view-pop";
            },
            styleSliderToolTip() {
                return {
                  "backgroundColor": "#e0e0e0",
                  "borderColor": "#e0e0e0",
                  "color": "#333"
                }
            },
            params()
            {
                var filter = this.$route.query.filter;
                if (filter) {
                    return filter.split(",");
                }
            }
            /*
            styleSliderProcessBg() {
                return {
                    backgroundColor:"#608197"
                }
            },

            styleSliderBg() {
                return {
                    backgroundColor:"#e0e0e0"
                }
            }
            */
        },
        created() {

        },
        methods: {
            sliderToolTipFormatter(value,lom_field, criterionIndex) {

                //Round to one decimal place if lom filed is technical/size
                if (lom_field === 'hkepc:technical/size') {

                    if (value == Math.max(...this.sliderRanges[criterionIndex])) {
                        return `${Math.ceil(Math.round(value / 1024 / 1024 * 10) / 10)}MB`
                    } else {
                        return `${Math.round(value / 1024 / 1024 * 10) / 10}MB`
                    }
                }
            },
            openFilter() {
                this.isShow = true;
                EventBus.$emit("closeMyDownload");
                //Freeze the mapping so that the filter settings can be restored if user cancels.
                this.filterMappingfrozen = _.cloneDeep(this.filterMapping);


                let xapijs = new XAPIJS(xapi_config, access_token);

                xapijs.interacted(
                    display_name,
                    membercode,
                    window.location.href,
                    "篩選"
                );
            },
            closeFilter() {

                //if user cancels the filter setting, compare the frozen mapping with those changes made by the user.
                //if there are any differences, restore to the frozen mapping
                for (let [index, item] of this.filterMappingfrozen.entries()) {
                    if (item.display_type === "checkbox" || item.display_type === "radio") {
                        if (item.filteredValues.join("") !==  this.filterMapping[index]["filteredValues"].join("")) {
                            this.filterMapping[index]["filteredValues"] = item.filteredValues;
                        }
                    } else if (item.display_type === "range") {
                        //if either min or max of the slider range has been changed, do restoring
                        if (item.filteredValues[0] !== this.sliderValues[index][0] ||  item.filteredValues[1] !== this.sliderValues[index][1]) {
                            this.filterMapping[index]["filteredValues"] = item.filteredValues;
                            //if the slider has been changed by user, restore the values from the frozen mapping
                            if (this.filterMapping[index]["filteredValues"].length) {
                                Vue.set(this.sliderValues, index, item.filteredValues);
                            //if the slider has never been updated by user, just restore from the slider ranges
                            } else {
                                this.sliderValues[index] = [Math.min(...this.sliderRanges[index]), Math.max(...this.sliderRanges[index])];
                            }
                        }
                    }
                }

                if (this.$refs.slider !== undefined) {
                    for (let slider of this.$refs.slider) {
                        slider.refresh();
                    }
                }

                this.isShow = false;
            },
            onSlided(ciiterionIndex) {
                this.filterMapping[ciiterionIndex]["filteredValues"] = this.sliderValues[ciiterionIndex];
            },
            setIsChecked(criterionIndex, optionKey) {

                if (this.filterMapping[criterionIndex]["filteredValues"].indexOf(optionKey) >= 0) {
                    return "checked";
                }

                return false;
            },
            resetFilter() {

                let sliderRangeIndices = [];
                let index = 0;
                for (let j=0; j< this.sliderRanges.length; j++) {
                    if (this.sliderRanges[j] !== undefined) {
                        index++;
                        sliderRangeIndices.push(index);
                    }
                }

                if (this.$refs.slider !== undefined) {
                    for (let i = 0; i < this.$refs.slider.length; i++) {
                        this.$refs.slider[i].setValue([Math.min(...this.sliderRanges[sliderRangeIndices[i]]), Math.max(...this.sliderRanges[sliderRangeIndices[i]])])
                    }
                }

                this.filterMapping = this.filterMapping.map(item=>{
                    item.filteredValues = [];
                    return item;
                });

                this.filterSubCate();

            },
            filterSubCate() {

                //Set whether the resource items should be filtered or not.
                let filteredIndices = [];
                let filteredIndicesGroup = [];

                let cateList = this.getFormattedResourceList();

                //Iterate all resource items
                for (let [index,item] of cateList.entries()) {

                    //used to calculate if all criteria are matched.
                    let matchCount = 0;

                    //Iterate the filter criteria
                    for (let filter of this.filterMapping) {

                        //For determining if the resource contains classification in the filter criteria,
                        //since resource classification doesn't necessarily include all the classifications in the filter criteria list
                        let isClassificationFound  = false;

                        //For each classification of the resource item, look for which one matches the filter criteria,
                        //and add matchCount if the resource matches the filtered value(s).
                        for (let classification of item.classification) {


                            if (classification.taxon_path.source === filter.classification) {

                                isClassificationFound = true;

                                //Two cases should be considered matched:
                                //1. If the classification value matches the options selected (e.g. resource is Grade 2, and option Grade 2 is selected.
                                //2. If no option is selected at all, then it must be matched.

                                //if classification has more than one value, then split it to array, and filter it
                                let arr_value = classification.taxon_path.terms.id.split(",");
                                let compare_result = arr_value.filter(arr_value => filter.filteredValues.includes(arr_value));

                                if (
                                    filter.filteredValues.indexOf(classification.taxon_path.terms.id) >=0 ||
                                    !filter.filteredValues.length ||
                                    compare_result.length > 0
                                ) {
                                    matchCount++;
                                    break;
                                }
                            }
                        }

                        //Consider it's a match only if the filter criterion doesn't appear in the resource, and no option is selected
                        if (!isClassificationFound && !filter.filteredValues.length) {
                            matchCount++;
                        }
                    }

                    //A particular resource item should display if all criteria are matched (which is an AND case)
                    //For example, the filter criteria are grade and file type. Let's say Grade 1 and docx are selected in the filter opations.
                    //If the resource item is of Grade 1 and it is a docx type, then matchCount should be 2.
                    //If all criteira are matched, it should not be filtered out.
                    //Then set false to filteredIndices or filteredIndicesGroup, to indicate it shouldn't be filtered out.
                    if (matchCount === this.filterMapping.length) {
                        if (item.groupIndex !== undefined) {

                            if (filteredIndicesGroup[item.groupIndex] === undefined) {
                                filteredIndicesGroup[item.groupIndex] = [];
                            }
                            filteredIndicesGroup[item.groupIndex].push(false)

                        } else {
                            filteredIndices.push(false);
                        }
                    //Otherwise, it should be filtered out, if not all criteria are matched.
                    } else {
                        if (item.groupIndex !== undefined) {

                            if (filteredIndicesGroup[item.groupIndex] === undefined) {
                                filteredIndicesGroup[item.groupIndex] = [];
                            }
                            filteredIndicesGroup[item.groupIndex].push(true)

                        } else {
                            filteredIndices.push(true);
                        }
                    }
                }

                //Freeze the mapping so that the filter settings can be restored if user cancels.
                this.filterMappingfrozen = _.cloneDeep(this.filterMapping);

                if (filteredIndices.length) {
                    this.$store.commit("resource_store/setFilteredItems", filteredIndices);
                }

                if(filteredIndicesGroup.length) {
                    this.$store.commit("resource_store/setFilteredItemsGroup", filteredIndicesGroup);
                }

                this.isShow = false;

            },
            /**
             * Used to distinguish whether the resource list is group type or not.
             * If it is a resource within a group, add a 'groupIndex' attribute to the resource item
             */
            getFormattedResourceList() {

                //attempted to get resource list array from the grouped raw data
                let resourceList = [];

                for (let [index,item] of this.storeResource.cate_list.entries()) {

                    if (item.resource !== undefined) {
                        item.resource = item.resource.map(el=>{
                            //use the groupIndex to set if item should be filtered
                            el.groupIndex = index;
                            return el;
                        });
                        resourceList  = resourceList.concat(item.resource);
                    }
                }

                //return the raw data if not group type; otherwise, return the formatted resourcelist
                if (resourceList.length) {
                     return resourceList;
                } else {
                    return this.storeResource.cate_list
                }

            },
            setFilteredValues(event, criterionIndex, optionIndex, key) {

                let index = this.filterMapping[criterionIndex]["filteredValues"].indexOf(key);

                if (event.target.checked) {
                    if (index < 0) {
                        if (event.target.type==="radio") {
                            this.filterMapping[criterionIndex]["filteredValues"] = [];
                        }
                        this.filterMapping[criterionIndex]["filteredValues"].push(key);
                    }
                } else {
                    if (index >= 0) {
                        this.filterMapping[criterionIndex]["filteredValues"].splice(index, 1);
                    }
                }
            },
            setFilterByUrl()
            {

                //set filter
                let self = this;
                if (self.params) {
                    if (self.params.length > 0) {
                        let key = 0;
                        for (let filter of this.filterMapping) {
                            self.params.forEach(function (value) {

                                filter.options.forEach(function(option) {
                                    if (option.id === value) {
                                        self.filterMapping[key]["filteredValues"].push(value);
                                    }
                                });


                            });
                            key++;

                        }
                        this.filterSubCate();

                    }
                }

            }
        },
        mounted() {
            EventBus.$on("setCriteria", (payload)=> {

                this.criteria = [];

                Vue.nextTick(() => {
                    for (let [index,item] of  payload.entries()) {

                        this.criteria.push(
                            {
                                "display_name": item.display_name,
                                "display_type": item.display_type,
                                "options": item.options,
                                "filteredValues": [],
                                "classification": item.classification,
                                "lom_field": item.lom_field.field,
                            }
                        )

                        if (item.display_type === "range") {
                            this.sliderRanges[index] = item.options.map(item => {
                                return item.value;
                            })

                            this.sliderValues[index] = [Math.min(...this.sliderRanges[index]), Math.max(...this.sliderRanges[index])];
                        }

                    }

                    this.filterMapping =  this.criteria;
                    this.filterMapping = this.filterMapping.map(item=>{
                        return {
                            display_type: item.display_type,
                            classification: item.classification,
                            filteredValues: item.filteredValues,
                            lom_field: item.lom_field,
                            options: item.options

                        }
                    });

                    this.setFilterByUrl();


                });
            });

            EventBus.$on("closeFilter", ()=>{
                this.closeFilter();
            });

        },
        watch: {
            isShow(value) {
                Vue.nextTick(()=>{
                    if (this.$refs.slider !== undefined) {
                        for (let slider of this.$refs.slider) {
                            slider.refresh();
                        }
                    }
                })

            }
        }
    }
</script>

<style scoped lang="scss">

    @import "~@sass/_variables.scss";
    @import "~@sass/_mixins.scss";

    input[type='radio'] + label,
    input[type='checkbox'] + label {
        font-size: 0.875rem;
        margin-right: 1.75rem;
        padding-left: 1.75rem;
        float: left;
        padding-top: 2px;
    }

    #filter li:last-child label {
        margin-right: 0;
    }


</style>



// WEBPACK FOOTER //
// resources/assets/js/components/SubCateFilter.vue